//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import wx from 'weixin-js-sdk'; 
export default {
  name: 'barOrder',
  components: {
  },
  data () {
    return {
      id:0,
      popUp:false,
      code:'',
      order:{
        log:[],
        factory:[],
        community:{}
      },
      number:'',
    }
  },
  created(){
    this.config();
  },
  mounted(){
    this.code = this.$route.params.code;
    if(this.code){
      this.getOrder();
    }
    // this.id = Number(this.$route.params.id);
    // this.changePop();
  
  },
  methods:{
     searchOrder(orderNo){
        this.$router.push({name:'searchOrder',params:{code:orderNo}})
    },
    copy(val){
        this.$func.copy(val,event);
    },
    scanQRCode(){
        let that = this;
        wx.ready(()=> {
            wx.scanQRCode({
            needResult: 1,
            scanType: ["barCode"],
            success: function (res) {
                setTimeout(()=>{
                    // that.formData[id] = res.resultStr.split(',')[1];
                    that.code = res.resultStr.split(',')[1];
                    that.getOrder();
                },300);
            }
            })
        });
        wx.error((res)=> {
            console.log(res)
            // alert(res.errMsg);
        })
    },  
    config(){
        let url = (window.location.href).split('#');
        if(url[0].indexOf('?') != '-1'){
            url = url[0].split('?');
        }
        this.$api.wxSign({url:url[0]}).then((res)=>{
            if(res){
                wx.config({
                    debug: false, 
                    appId: res.data.appId,
                    timestamp: res.data.timestamp,
                    nonceStr: res.data.nonceStr,
                    signature:res.data.signature,
                    jsApiList: [
                        "scanQRCode"
                    ]
                });
            }
        })
    },
    showPic(urls,url){
      wx.previewImage({
        current: url ? url : urls[0], // 当前显示图片的 http 链接
        urls: urls // 需要预览的图片 http 链接列表
      });
    },
    getOrder(){
      let that = this;
      if(!this.code){
        that.$func.showToast('衣物条码无效');
        return ;
      }
      // if(code.length != 12){
      //   that.$func.showToast('子订单码无效');
      //   return ;
      // }
      that.$func.startLoading();
      this.$api.barOrder({code:this.code}).then((res)=>{
        if(res){
          that.order = res.data;
          that.$func.endLoading();
        } 
      })  
    },
    submit(){
      let that = this;
      if(!this.number){
        that.$func.showToast('请输入挂点');
        return ;
      }
      if(!this.order.factory_wash_code){
        that.$func.showToast('输入衣物条码或扫条码');
        return ;
      }
      this.$api.up({code:this.order.factory_wash_code,number:that.number}).then((res)=>{
        if(res){
           that.$func.showToast('已上挂');
           that.popUp = false;
        } 
      })  
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/barOrder.vue